import { render, staticRenderFns } from "./RegisterSoleProprietorForm.vue?vue&type=template&id=e64a198c&scoped=true&lang=pug"
import script from "./RegisterSoleProprietorForm.vue?vue&type=script&lang=js"
export * from "./RegisterSoleProprietorForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterSoleProprietorForm.vue?vue&type=style&index=0&id=e64a198c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64a198c",
  null
  
)

export default component.exports